<template>
  <div>
    <div id="modelLoader" class="modal fade showloader" tabindex="-4" role="dialog" aria-hidden="true" data-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content modal-content-progress">
          <div class="loadersmall"></div>
        </div>
      </div>
    </div>
  </div>   
</template>

<script>
import auth from '../../auth/initAuth'

export default {
  name: 'Callback',
  mounted () {
    let hash = window.location.hash.startsWith('#/callback') ? window.location.hash.substring(10) : window.location.hash

    auth.parseHash(hash)
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/callback/Callback.vue